import {  MODULE } from "./consts";
import SettingsDashboard from "./SettingsDashboard";

export const SettingsRoutes = [
  { path: `/${MODULE}`, exact: true, component: SettingsDashboard },
];

export default SettingsRoutes;
